import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import _, { find } from 'lodash';
import Toggle from 'react-toggle';
import { useTranslation } from 'react-i18next'

import SelectionEventVideoType from './SelectionEventVideoType'
import SelectionSoundType from './SelectionSoundType'
import InfoPop from '../../common/InfoPop'
import CustomButton from '../../CustomButton'
import CustomReactBootstrapSlider from '../../CustomReactBootstrapSlider'
import LabelTag from '../../dump/LabelTag'
import ModalDelete from '../modals/ModalDelete'

import { isInternalUser } from '../../helpers/constants'
import SoundPlayButton from "./SoundPlayButton";

const FleetConfigurationEvent = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.fleetConfigurationEvent' });
	const { settingsType, user, configuration, configurationdv6, configurationdv7, event_types, setConfiguration, fillFormBoolean, fillFormInt, fillForm } = props;
	const [showModalDMSSeatbeltToggle, setShowModalDMSSeatbeltToggle] = useState(false);
	const [tabKey, setTabKey] = useState(1);

	const defaultConfigurationDv7 = useSelector(state => state.configs.defaultConfigurationDv7);
	const userRole = user.roles[0]
	const isDV6 = settingsType === 'dv6'
	const isDV4 = settingsType === 'dv4'
	const isDV7 = settingsType === 'dv7'
	const currentConfig = isDV6 ? configurationdv6 : isDV7 ? configurationdv7 : configuration
	const Sensor4 = find(currentConfig.Event.Sensor, o => o.index === 4);

	useEffect(() => {
		if (tabKey !== 1) setTabKey(1);
	}, [isDV6]);

	const getSpeedSlider = (speedMph = 0, speedKph = 0) => {
		if (currentConfig.System.SpeedUnit === 1) {
			return speedMph
		}
		return speedKph || Math.round(speedMph * 1.609344)
	}

	const dv6ADASSettings = [
		{ name: t('nameForwardCollision'), event_setting: 'ForwardCollision', event_type_name: 'dv6_forward_collision', description: t('descriptionForwardCollision') },
		{ name: t('nameHeadwayMonitoring'), event_setting: 'Headway', event_type_name: 'dv6_headway_monitoring', description: t('descriptionHeadwayMonitoring') },
		{ name: t('nameTailgating'), event_setting: 'FollowingDistance', event_type_name: 'dv6_following_distance', description: t('descriptionTailgating') },
	]

	const dv6DMSSettings = [
		{ name: t('nameDistraction'), event_setting: 'Distraction', event_type_name: 'dv6_distraction', description: t('descriptionDistraction'), voice_prompt_setting: 'System.Chimes.Distraction', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Distraction.SpeedThreshold" } },
		{ name: t('nameYawning'), event_setting: 'Yawning', event_type_name: 'dv6_yawning', description: t('descriptionYawning'), voice_prompt_setting: 'System.Chimes.Yawning', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Yawning.SpeedThreshold" } },
		{ name: t('nameDozing'), event_setting: 'Dozing', event_type_name: 'dv6_drowsiness', description: t('descriptionDozing'), voice_prompt_setting: 'System.Chimes.Drowsiness', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Dozing.SpeedThreshold" } },
		{ name: t('nameSmoking'), event_setting: 'Smoking', event_type_name: 'dv6_smoking', description: t('descriptionSmoking'), voice_prompt_setting: 'System.Chimes.Smoking', sliderSpeedObj: { min: 0, max: getSpeedSlider(35), step: 1, name: "Event.Dms.Smoking.SpeedThreshold" } },
		// { name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv6_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt', isInternal: true },
		{ name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv6_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Seatbelt.SpeedThreshold" } },
		{ name: t('namePhoneUse'), event_setting: 'PhoneUse', event_type_name: 'dv6_phone_use', description: t('descriptionPhoneUse'), voice_prompt_setting: 'System.Chimes.PhoneUse', sliderSpeedObj: { min: 0, max: getSpeedSlider(35), step: 1, name: "Event.Dms.PhoneUse.SpeedThreshold" } },
	]

	const dv6SensitivitySettings = [
		{
			name: t('nameHighG-Force'),
			event_setting: 'Accelerometer',
			event_type_name: 'dv6_fatal_gsensor',
			description: t('descriptionHighG-Force'),
			sliderObj: { id: 1, min: 1.0, max: 4.0, step: 0.1, name: "Event.Accelerometer.FatalThreshold.X" },
			sliderObjParkingTreshold: { min: 0, max: 0.5, step: 0.01, name: "Event.Accelerometer.ParkingThreshold.X", label: t('parkingSensitivity') }
		},
		{ name: t('nameHarshBraking'), event_setting: 'HarshBraking', event_type_name: 'dv6_harsh_braking', description: t('descriptionHarshBraking'), sliderObj: { id: 2, min: 7, max: 17, step: 0.1, name: "Event.HarshBraking.Threshold" }, sublabel: t('sublabelHarshBraking') },
		{ name: t('nameHarshAcceleration'), event_setting: 'HarshAccel', event_type_name: 'dv6_harsh_accel', description: t('descriptionHarshAcceleration'), sliderObj: { id: 3, min: 7, max: 17, step: 0.1, name: "Event.HarshAccel.Threshold" }, sublabel: t('sublabelHarshAcceleration') },
	]

	const dv7ADASSettings = [
		{ name: t('nameForwardCollision'), event_setting: 'ForwardCollision', event_type_name: 'dv7_forward_collision', description: t('descriptionForwardCollision') },
		{ name: t('nameHeadwayMonitoring'), event_setting: 'Headway', event_type_name: 'dv7_headway_monitoring', description: t('descriptionHeadwayMonitoring') },
		{ name: t('nameTailgating'), event_setting: 'FollowingDistance', event_type_name: 'dv7_following_distance', description: t('descriptionTailgating') },
	]

	const dv7ADASSettingsPart2 = [
		{
			name: t('Front_Vehicle_Start_Alert'),
			event_setting: 'FrontVehicleStart',
			event_type_name: 'dv7_front_vehicle_start',
			description: t('Front_Vehicle_Start_Alert_description'),
			voice_prompt_setting: 'System.Chimes.FrontVehicleStart',
			sliderObj: { id: 5, min: 0, max: 10, step: 0.1, name: "Event.Adas.FrontVehicleStart.Sensitivity" }
		},
		{
			name: t('Traffic_Light_Compliance_Warning'),
			event_setting: 'TrafficLightViolation',
			event_type_name: 'dv7_traffic_light_violation',
			description: t('Traffic_Light_Compliance_Warning_description'),
			voice_prompt_setting: 'System.Chimes.TrafficLightViolation',
			sliderObj: { id: 6, min: 0, max: 10, step: 0.1, name: "Event.Adas.TrafficLightViolation.Sensitivity" },
		},
		{
			name: t('Stop_Sign_Compliance_Warning'),
			event_setting: 'StopSignViolation',
			event_type_name: 'dv7_stop_sign_violation',
			description: t('Stop_Sign_Compliance_Warning_description'),
			voice_prompt_setting: 'System.Chimes.StopSignViolation',
			sliderObj: { id: 7, min: 0, max: 10, step: 0.1, name: "Event.Adas.StopSignViolation.Sensitivity", hideNumberField: true },
		},
		{
			name: t('Pedestrian_Collision_Warning'),
			event_setting: 'PedestrianWarning',
			event_type_name: 'dv7_pedestrian_collision_warning',
			description: t('Pedestrian_Collision_Warning_description'),
			voice_prompt_setting: 'System.Chimes.PedestrianWarning',
			sliderObj: { id: 8, min: -2, max: 2, step: 0.1, name: "Event.Adas.PedestrianWarning.Sensitivity", hideNumberField: true },
		},
		{
			name: t('Lane_Departure_Warning'),
			event_setting: 'LaneDeparture',
			event_type_name: 'dv7_lane_departure',
			description: t('Lane_Departure_Warning_description'),
			voice_prompt_setting: 'System.Chimes.LaneDeparture',
			sliderSpeedObj: { min: getSpeedSlider(1), max: getSpeedSlider(15), step: 1, name: "Event.Adas.LaneDeparture.SpeedThreshold" },
		},
	]

	const blindSpotsSettings = {
		name: t('Blind_Spot_Detection_Warning'),
		description: t('Blind_Spot_Detection_Warning_description'),
		settings: [
			{
				name: (<><span>{t('urban')}</span>&nbsp;({t('vehicleSpeed')} &lt; 15 mph)</>),
				event_setting: 'BlindSpotWarning',
				event_sub_setting: 'Urban',
				event_type_name: 'dv7_blind_spot_warning_urban',
				sliderSpeedObj: {
					min: getSpeedSlider(0),
					max: getSpeedSlider(15),
					step: 1,
					name: "Event.BlindSpotWarning.Urban.SpeedThreshold"
				}
			},
			{
				name: (<><span>{t('standard')}</span>&nbsp;({t('vehicleSpeed')} &gt;= 15 mph)</>),
				event_setting: 'BlindSpotWarning',
				event_sub_setting: 'Standard',
				event_type_name: 'dv7_blind_spot_warning_standard',
				sliderSpeedObj: {
					min: getSpeedSlider(16),
					max: getSpeedSlider(35),
					step: 1,
					name: "Event.BlindSpotWarning.Standard.SpeedThreshold"
				}
			},
		]
	}

	const speedLimitSettings = {
		name: t('Speed_Limit_Sign_Detection'),
		description: t('Speed_Limit_Sign_Detection_description'),
		sliderSpeedObj: {
			min: getSpeedSlider(0),
			max: getSpeedSlider(35),
			step: 1,
			name: "Event.SpeedLimitViolation.SpeedThreshold",
			description: t('minSpeedNote')
		},
		settings: [
			{
				name: (<><span>{t('lowSpeedingLabel')}</span>&nbsp;(+1 {t('to')} +5 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Low',
				event_type_name: 'dv7_speed_limit_violation_low'
			},
			{
				name: (<><span>{t('moderateSpeedingLabel')}</span>&nbsp;(+6 {t('to')} +10 mph PSL))</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Moderate',
				event_type_name: 'dv7_speed_limit_violation_moderate'
			},
			{
				name: (<><span>{t('highSpeedingLabel')}</span>&nbsp;(+11 {t('to')} +15 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'High',
				event_type_name: 'dv7_speed_limit_violation_high'
			},
			{
				name: (<><span>{t('severeSpeedingLabel')}</span>&nbsp;(&ge; +16 mph PSL)</>),
				event_setting: 'SpeedLimitViolation',
				event_sub_setting: 'Severe',
				event_type_name: 'dv7_speed_limit_violation_severe'
			},
		]
	}

	const dv7DMSSettings = [
		{ name: t('nameDistraction'), event_setting: 'Distraction', event_type_name: 'dv7_distraction', description: t('descriptionDistraction'), voice_prompt_setting: 'System.Chimes.Distraction', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Distraction.SpeedThreshold" } },
		{ name: t('nameYawning'), event_setting: 'Yawning', event_type_name: 'dv7_yawning', description: t('descriptionYawning'), voice_prompt_setting: 'System.Chimes.Yawning', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Yawning.SpeedThreshold" } },
		{ name: t('nameDozing'), event_setting: 'Dozing', event_type_name: 'dv7_drowsiness', description: t('descriptionDozing'), voice_prompt_setting: 'System.Chimes.Drowsiness', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Dozing.SpeedThreshold" } },
		{ name: t('nameSmoking'), event_setting: 'Smoking', event_type_name: 'dv7_smoking', description: t('descriptionSmoking'), voice_prompt_setting: 'System.Chimes.Smoking', sliderSpeedObj: { min: 0, max: getSpeedSlider(35), step: 1, name: "Event.Dms.Smoking.SpeedThreshold" } },
		{ name: t('nameSeatbelt'), event_setting: 'Seatbelt', event_type_name: 'dv7_seatbelt', description: t('descriptionSeatbelt'), voice_prompt_setting: 'System.Chimes.Seatbelt', sliderSpeedObj: { min: getSpeedSlider(5), max: getSpeedSlider(35), step: 1, name: "Event.Dms.Seatbelt.SpeedThreshold" } },
		{ name: t('namePhoneUse'), event_setting: 'PhoneUse', event_type_name: 'dv7_phone_use', description: t('descriptionPhoneUse'), voice_prompt_setting: 'System.Chimes.PhoneUse', sliderSpeedObj: { min: 0, max: getSpeedSlider(35), step: 1, name: "Event.Dms.PhoneUse.SpeedThreshold" } },
	]

	const dv7SensitivitySettings = [
		{
			name: t('nameHighG-Force'),
			event_setting: 'Accelerometer',
			event_type_name: 'dv7_fatal_gsensor',
			description: t('descriptionHighG-Force'),
			sliderObj: { id: 1, min: 1.0, max: 4.0, step: 0.1, name: "Event.Accelerometer.FatalThreshold.X" },
		},
		{ name: t('nameHarshBraking'), event_setting: 'HarshBraking', event_type_name: 'dv7_harsh_braking', description: t('descriptionHarshBraking'), sliderObj: { id: 2, min: 7, max: 17, step: 0.1, name: "Event.HarshBraking.Threshold" }, sublabel: t('sublabelHarshBraking') },
		{ name: t('nameHarshAcceleration'), event_setting: 'HarshAccel', event_type_name: 'dv7_harsh_accel', description: t('descriptionHarshAcceleration'), sliderObj: { id: 3, min: 7, max: 17, step: 0.1, name: "Event.HarshAccel.Threshold" }, sublabel: t('sublabelHarshAcceleration') },
		{ name: t('G-Sensor_Wake-Up'), event_setting: 'GSensorWakeUp', event_type_name: 'dv7_gsensor_wakeup', description: t('G-Sensor_Wake-Up_description'), sliderObj: { id: 4, min: 0, max: 10, step: 0.1, name: "Event.GSensorWakeUp.Sensitivity" } },
		{ name: t('Dangerous_Backing-Up_Alerts'), event_setting: 'BackUpWarning', event_type_name: 'dv7_backup_warning', description: t('Dangerous_Backing-Up_Alerts_description') },
	]

	const dv4ADASSettings = [
		{ name: t('nameLaneDepartureWarning'), event_setting: 'LaneDeparture', description: t('descriptionLaneDepartureWarning') },
		{ name: t('nameForwardCollisionWarning'), event_setting: 'ForwardCollision', description: t('descriptionForwardCollisionWarning') },
		{ name: t('namePedestrianCollisionWarning'), event_setting: 'Pedestrian', description: t('descriptionPedestrianCollisionWarning') },
	]

	const dv4DMSSettings = [
		{ name: t('nameDistractionDv4'), event_setting: 'Distraction', event_type_name: 'dv4_distraction', description: t('descriptionDistractionDv4') },
		{ name: t('nameDrowsiness/LookingDown'), event_setting: 'Dozing', event_type_name: 'dv4_drowsiness', description: t('descriptionDrowsiness/LookingDown') },
		{ name: t('namePhoneUse/HandtoHead'), event_setting: 'PhoneUse', event_type_name: 'dv4_phone_use', description: t('descriptionPhoneUse/HandtoHead') },
	]

	let unit = 'mph'
	if (currentConfig.System.SpeedUnit === 2) {
		unit = 'kph'
	}

	const fillFormSensors = (e, idx) => {
		const { target } = e;
		const { name } = target;
		let value = target.value * 1;
		if (target.type === 'checkbox') {
			value = !!(target.checked);
		}
		else if (target.type === 'button') {
			value = target.value === 'true'
		}

		if (idx === 8) {
			currentConfig.Event.Sensor[4].SendToCloud = value;
			// setConfiguration({ configurationdv6 })
		}

		currentConfig.Event.Sensor = currentConfig.Event.Sensor.map((sensor, sidx) => {
			if (idx === sensor.index) {
				sensor[name] = value;
				return sensor;
			}

			return sensor;
		});

		if (isDV6) {
			setConfiguration({ configurationdv6: currentConfig });
		} else if (isDV7) {
			setConfiguration({ configurationdv7: currentConfig });
		} else {
			setConfiguration({ configuration: currentConfig });
		}

	}

	const getSpeedValue = (name) => {
		const { configurationdv6, configurationdv7 } = props

		const res = (configurationdv) => {
			let res = _.get(configurationdv, name, 0);
			if (currentConfig.System.SpeedUnit === 1) {
				res = Math.round((res / 1.609344) * 1e2) / 1e2
			}

			return +res.toFixed(0)
		}

		if (isDV6) return res(configurationdv6);
		if (isDV7) return res(configurationdv7);

		return 0;
	}

	const onSpeedChange = (speed, name) => {
		let { setConfiguration } = props
		let value = speed * 1

		const isMPH = currentConfig.System.SpeedUnit === 1;
		if (isMPH) value = Math.round((value * 1.609344) * 1e2) / 1e2;

		let configurationdv = _.set(currentConfig, name, value);

		if (name === 'Event.Adas.Headway.SpeedThreshold') {
			const obj = { target: { name: 'Event.Adas.Headway.SpeedUnit', value: isMPH ? "mph" : "kph" } };
			fillForm(obj, settingsType);
			configurationdv = _.set(currentConfig, 'Event.Adas.FollowingDistance.SpeedThreshold', value)
		}
		else if (name === 'Event.Dms.Dozing.SpeedThreshold') {
			configurationdv = _.set(currentConfig, 'Event.Dms.HeadDown.SpeedThreshold', value)
		}

		isDV6 && setConfiguration({ configurationdv6: configurationdv })
		isDV7 && setConfiguration({ configurationdv7: configurationdv })
	}

	const onEventDistanceTimeChange = (e, name) => {
		if (name === 'Event.Adas.Headway.Ttc.TriggerThreshold') {
			fillForm(e, settingsType, name)
		} else {
			fillFormInt(e, settingsType, name)
		}
	}

	const setEventTypes = (argTypeValue) => {
		setConfiguration({ event_types: { ...event_types, ...argTypeValue } })
	}

	const setSoundTypes = (event_setting, argTypeValue, event_sub_setting) => {
		if (event_setting === "ForwardCollision") {
			currentConfig.System.Chimes.ForwardCollision = !!+argTypeValue;
		} else if (event_setting === "SpeedLimitViolation" && event_sub_setting) {
			currentConfig.System.Chimes[event_setting][event_sub_setting] = +argTypeValue;
		} else if (event_setting === "TrafficLightViolation" && event_sub_setting) {
			currentConfig.System.Chimes[event_setting][event_sub_setting] = +argTypeValue;
		} else if (event_setting === "StopSignViolation" && event_sub_setting) {
			currentConfig.System.Chimes[event_setting][event_sub_setting] = +argTypeValue;
		} else if (event_setting !== "CameraObstruction") {
			currentConfig.System.Chimes[event_setting] = +argTypeValue;
		} else {
			currentConfig.System.Chimes.CameraObstruction.SoundType = +argTypeValue;
		}

		isDV6 && setConfiguration({ configurationdv6: currentConfig });
		isDV7 && setConfiguration({ configurationdv7: currentConfig });
	}

	const onSensitivityTresholdChange = (e, name) => {
		const value = e.target.value * 1

		if (name === 'Event.Accelerometer.FatalThreshold.X') {
			currentConfig.Event.Accelerometer.FatalThreshold.X = value
			currentConfig.Event.Accelerometer.FatalThreshold.Y = value
		} else if (name === 'Event.Accelerometer.ParkingThreshold.X') {
			currentConfig.Event.Accelerometer.ParkingThreshold.X = value
			currentConfig.Event.Accelerometer.ParkingThreshold.Y = value
		}

		if (isDV6) {
			setConfiguration({ configurationdv6: currentConfig });
		} else if (isDV7) {
			setConfiguration({ configurationdv7: currentConfig });
		} else {
			setConfiguration({ configuration: currentConfig });
		}
	}

	const resetSoundsToDefault = (e, event_setting, event_sub_setting) => {
		const checked = e.target.checked;
		if (checked && settingsType === 'dv7') {
			if (['TrafficLightViolation', 'StopSignViolation'].includes(event_setting)) {
				setSoundTypes(event_setting, defaultConfigurationDv7.System.Chimes[event_setting][1], 1);
				setSoundTypes(event_setting, defaultConfigurationDv7.System.Chimes[event_setting][2], 2);
			} else if (['FrontVehicleStart', 'GSensorWakeUp'].includes(event_setting)) {
				setSoundTypes(event_setting, defaultConfigurationDv7.System.Chimes[event_setting])
			} else if (event_setting === 'BlindSpotWarning') {
				fillFormBoolean(
					null,
					settingsType,
					`System.Chimes.${event_setting}.${event_sub_setting}`,
					defaultConfigurationDv7.System.Chimes[event_setting][event_sub_setting]
				)
			} else if (event_setting === 'SpeedLimitViolation') {
				if (event_setting === 'Low') {
					fillFormBoolean(
						null,
						settingsType,
						`System.Chimes.${event_setting}.${event_sub_setting}`,
						defaultConfigurationDv7.System.Chimes[event_setting][event_sub_setting]
					)
				} else {
					setSoundTypes(event_setting, defaultConfigurationDv7.System.Chimes[event_setting][event_sub_setting], event_sub_setting)
				}
			} else if (event_setting === 'BackUpWarning') {
				fillFormBoolean(
					null,
					settingsType,
					`System.Chimes.${event_setting}`,
					defaultConfigurationDv7.System.Chimes[event_setting]
				)
			}
		}
	}

	const eventSpeedRender = (argObject) => {
		const { min, max, step, name, description } = argObject;

		return (
			<>
				{description ? (
					<p style={{ fontWeight: 600 }}>{description}</p>
				) : ''}
				<div className="toggle-wrapper slider-wrapper block">
					<label className="settings-title mb-10">{t('titleMinimumSpeed')}</label>
					<div className="toggle-wrapper slider-wrapper p-0 no-border">
						<div className="slider-wrapper header-slider">
							<div className="slider-minmax-value min-value">
								{`${min} ${currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}`}
							</div>
							<CustomReactBootstrapSlider
								name={name}
								min={min}
								max={max}
								step={step}
								tooltip="show"
								value={getSpeedValue(name)}
								change={(e) => onSpeedChange(e.target.value, name)}
							/>
							<div className="slider-minmax-value max-value">
								{`${max} ${currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}`}
							</div>
						</div>
						<div>
							<input
								type="number"
								name={name}
								step={step}
								min={min}
								max={max}
								value={getSpeedValue(name)}
								className="vehicle-search number-input mr-10 pt-5"
								onChange={(e) => onSpeedChange(e.target.value, name)}
							/>
							<label
								style={{ marginLeft: '6px' }}>{currentConfig.System.SpeedUnit === 1 ? 'MPH' : 'KPH'}</label>
						</div>
					</div>
				</div>
			</>
		)
	}

	const eventSensitivityRender = (argObject, event_setting) => {
		const { min, max, step, name, label } = argObject;
		// FWSD-6898
		const tooltipFormatter = (value) => {
			let res = value

			if (!['Accelerometer'].includes(event_setting)) {
				res = (value * 0.28 / 9.81).toFixed(2)
			}

			return `${Math.abs(res)} Gs`
		}

		return (
			<div className="toggle-wrapper slider-wrapper">
				<label className="settings-title">{label || t('titleSensitivity')}</label>
				<div className="backlight-slider">
					<CustomReactBootstrapSlider
						name={name}
						max={max}
						min={min}
						step={step}
						tooltip="show"
						reversed={true}
						value={_.get(currentConfig, name, '')}
						formatter={tooltipFormatter}
						change={(e) => {
							if (['Accelerometer'].includes(event_setting)) {
								onSensitivityTresholdChange(e, name)
							} else {
								fillFormInt(e, settingsType, name)
							}
						}}
					/>
					<InfoPop
						title={t('infoPopTitle')}
						body={t('infoPopBody')}
						placement='top'
					>
						<div className="temp-bar-container slider slider-horizontal mt-10">
							<div className="cold temp-bar">{t('tempBarLessSensitive')}</div>
							<div className="med temp-bar" />
							<div className="hot temp-bar">{t('tempBarMoreSensitive')}</div>
						</div>
					</InfoPop>
				</div>
			</div>
		)
	}

	const eventDistanceTimeRender = (argObject) => {
		const { min, max, step, name, hideNumberField } = argObject

		return (
			<div className="toggle-wrapper slider-wrapper block">
				<label className="settings-title mb-10">{t('titleFollowingDistanceTime')}</label>
				<div className="toggle-wrapper slider-wrapper p-0 no-border">
					<div className="backlight-slider mr-20">
						<CustomReactBootstrapSlider
							name={name}
							max={max}
							min={min}
							step={step}
							tooltip="show"
							value={_.get(currentConfig, name, '')}
							change={(e) => onEventDistanceTimeChange(e, name)}
						/>
						<InfoPop
							title={t('infoPopTitle')}
							body={t('infoPopBody')}
							placement='top'
						>
							<div className="temp-bar-container slider slider-horizontal mt-10">
								<div className="cold temp-bar">{t('tempBarLessSensitive')}</div>
								<div className="med temp-bar" />
								<div className="hot temp-bar">{t('tempBarMoreSensitive')}</div>
							</div>
						</InfoPop>
					</div>
					{!hideNumberField ? (
						<div>
							<input
								type="number"
								name={name}
								step={step}
								max={max}
								min={min}
								value={_.get(currentConfig, name, 0)}
								className="vehicle-search number-input mr-10 pt-5"
								onChange={(e) => onEventDistanceTimeChange(e, name)}
							/>
							<label style={{ marginLeft: '6px' }}>{t('textSeconds')}</label>
						</div>
					) : ''}
				</div>
			</div>
		)
	}

	const DMSSettingRender = (dmsSetting) => {
		const { name, event_setting, event_type_name, isInternal, description, voice_prompt_setting, sliderSpeedObj } = dmsSetting;
		const currentSensitivity = +_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`);
		const customSensitivityRange = currentSensitivity < -1 || currentSensitivity > 1;
		// FWSD-7044
		const onToggleClick = (e) => {
			if (e.target.name === 'Event.Dms.Seatbelt.Enabled' && e.target.checked) {
				setShowModalDMSSeatbeltToggle({
					function: () => {
						if (!isDV4) {
							fillForm({ target: { name: e.target.name, checked: true } }, settingsType)
						} else {
							fillFormBoolean({ target: { name: e.target.name, checked: true } }, settingsType)
						}
						setShowModalDMSSeatbeltToggle(false)
					}
				})
			}
			// FWSD-7081
			else if (e.target.name === 'Event.Dms.Dozing.Enabled') {
				fillFormBoolean({ target: { name: 'Event.Dms.HeadDown.Enabled', checked: e.target.checked } }, settingsType)
				if (!isDV4) {
					fillForm({ target: { name: 'Event.Dms.Dozing.Enabled', checked: e.target.checked } }, settingsType)
				} else {
					fillFormBoolean({ target: { name: 'Event.Dms.Dozing.Enabled', checked: e.target.checked } }, settingsType)
				}
			}
			else {
				if (!isDV4) {
					fillForm(e, settingsType)
				}
				else {
					fillFormBoolean(e, settingsType)
				}
			}
		}

		const onSensitivityClick = (e, ...arg) => {
			if (e.target.name === 'Event.Dms.Dozing.Sensitivity') {
				fillForm({ target: { name: 'Event.Dms.Dozing.Sensitivity', checked: e.target.checked } }, ...arg)
				fillForm({ target: { name: 'Event.Dms.HeadDown.Sensitivity', checked: e.target.checked } }, ...arg)
			}
			else {
				fillForm(e, ...arg)
			}
		}

		if (isInternal && !isInternalUser(userRole)) {
			return <div key="empty" />
		} else {
			return (
				<div key={name} className="settings-card">
					<div className="card-header">
						<div>
							{isDV4 && 'DMS - '}{name}
							{isDV4 && <span className="subtitle">{t('subtitleRequires')}</span>}
							{isInternal && <LabelTag text={t('textInternal')} tag_type='ml-10 internal' />}
						</div>
						<Toggle
							name={`Event.Dms.${event_setting}.Enabled`}
							checked={_.get(currentConfig, `Event.Dms.${event_setting}.Enabled`)}
							icons={false}
							// onChange={(e) => fillFormBoolean(e, settingsType)}
							onChange={onToggleClick}
						/>
					</div>
					<div className="card-body">
						<p>{description}</p>
						{/* anumation of card-body content displaing with delay 0.5s */}
						<div className={`${!currentConfig.Event.Dms[event_setting].Enabled ? 'hide' : ''}`}>
							<SelectionEventVideoType
								name={event_type_name}
								value={event_types[event_type_name]}
								setEventTypes={setEventTypes}
								labelPosition="top"
							/>
							{!isDV4 && (event_setting === "Seatbelt" || event_setting === "Distraction") &&
								<SelectionSoundType
									name={event_setting}
									value={currentConfig.System.Chimes[event_setting]}
									setSoundTypes={setSoundTypes}
								/>}

							{!isDV4 &&
								<>
									{(event_setting !== "Seatbelt" && event_setting !== "Distraction") &&
										<div className="toggle-wrapper">
											<label className="settings-title">{t('titleEventVoicePrompt')}</label>
											<div>
												<Toggle
													name={voice_prompt_setting}
													checked={_.get(currentConfig, voice_prompt_setting, '')}
													icons={false}
													onChange={(e) => fillFormBoolean(e, settingsType)}
												/>
												<SoundPlayButton soundKeyName={event_setting} iconButton value={_.get(currentConfig, voice_prompt_setting, '') ? 1 : 0} />
											</div>
										</div>}

									<div className="toggle-wrapper button-group">
										<label className="settings-title">{t('settingsTitleSensitivity')}</label>
										<div className="button-group">
											{customSensitivityRange ? <div className="dms-custom-settings-label">{t('customSettingApplied')}</div> : ''}
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === -1)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												onClick={(e) => onSensitivityClick(e, settingsType, '', -1)}
											>
												{t('btnLessSensitive')}
											</CustomButton>
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === 0)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												onClick={(e) => onSensitivityClick(e, settingsType, '', 0)}
											>
												{t('btnDefault')}
											</CustomButton>
											<CustomButton
												variant="toggle-group"
												active={(+_.get(currentConfig, `Event.Dms.${event_setting}.Sensitivity`) === 1)}
												name={`Event.Dms.${event_setting}.Sensitivity`}
												onClick={(e) => onSensitivityClick(e, settingsType, '', 1)}
											>
												{t('btnMoreSensitive')}
											</CustomButton>
										</div>
									</div>

									{eventSpeedRender(sliderSpeedObj)}
								</>
							}
						</div>
					</div>
				</div>
			)
		}
	}

	const ADASSettingRender = (adasSetting) => {
		const { name, event_setting, event_type_name, description, sliderObj, sliderSpeedObj } = adasSetting
		return (
			<div key={name} className="settings-card">
				<div className="card-header">
					<div>
						{isDV4 && 'ADAS - '}{name}
						{isDV4 && <span className="subtitle">{t('adasSubtitleRequires')}</span>}
					</div>
					<Toggle
						name={`Event.Adas.${event_setting}.Enabled`}
						checked={currentConfig.Event.Adas[event_setting]?.Enabled}
						icons={false}
						onChange={(e) => {
							if (!isDV4) {
								fillForm(e, settingsType);
								resetSoundsToDefault(e, event_setting);
							} else {
								fillFormBoolean(e, settingsType)
							}
						}}
					/>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{/* anumation of card-body content displaing with delay 0.5s */}
					<div className={`${!currentConfig.Event.Adas[event_setting]?.Enabled ? 'hide' : ''}`}>
						{!isDV4 &&
							<>
								<SelectionEventVideoType
									name={event_type_name}
									value={event_types[event_type_name]}
									setEventTypes={setEventTypes}
								/>
								{['TrafficLightViolation'].includes(event_setting) ? (
									<>
										<SelectionSoundType
											label={t('signalApproachWarning')}
											name={event_setting}
											subType={1}
											value={currentConfig.System.Chimes[event_setting][1]}
											setSoundTypes={setSoundTypes}
										/>
										<SelectionSoundType
											label={t('signalViolationWarning')}
											name={event_setting}
											subType={2}
											value={currentConfig.System.Chimes[event_setting][2]}
											setSoundTypes={setSoundTypes}
										/>
									</>
								) : ''}
								{['StopSignViolation'].includes(event_setting) ? (
									<>
										<SelectionSoundType
											label={t('rollingStop')}
											name={event_setting}
											subType={1}
											value={currentConfig.System.Chimes[event_setting][1]}
											setSoundTypes={setSoundTypes}
										/>
										<SelectionSoundType
											label={t('bypassStop')}
											name={event_setting}
											subType={2}
											value={currentConfig.System.Chimes[event_setting][2]}
											setSoundTypes={setSoundTypes}
											customSoundsOptions={[
												{
													value: "0",
													label: i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.disableAudio')
												},
												{
													value: "3",
													label: `${i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.eventChime')} + ${i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.eventVoicePrompt')}`
												},
											]}
										/>
									</>
								) : ''}
								{!['TrafficLightViolation', 'StopSignViolation', 'LaneDeparture'].includes(event_setting) ? (
									<SelectionSoundType
										name={event_setting}
										value={
											event_setting === "ForwardCollision" ?
												+currentConfig.System.Chimes.ForwardCollision :
												currentConfig.System.Chimes[event_setting]
										}
										setSoundTypes={setSoundTypes}
										{...(event_setting === "ForwardCollision" && {
											customSoundsOptions: [
												{
													value: "0",
													label: i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.disableAudio')
												},
												{
													value: "1",
													label: i18n.t('manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType.eventChime')
												},
											]
										})}
									/>
								) : ''}
								{event_setting === 'LaneDeparture' ? (
									<div className="toggle-wrapper">
										<label
											className="settings-title">{t('titleEventChime')}</label>

										<div>
											<Toggle
												name={`System.Chimes.${event_setting}`}
												checked={currentConfig.System.Chimes[event_setting]}
												icons={false}
												onChange={(e) => {
													const checked = e.target.checked;
													const value = checked ? 2 : 0;
													fillFormBoolean(e, settingsType, null, value);
												}}
											/>
											<SoundPlayButton iconButton
												value={currentConfig.System.Chimes[event_setting] ? 2 : 0} />
										</div>
									</div>
								) : ''}
								{['LaneDeparture'].includes(event_setting) && eventSpeedRender(sliderSpeedObj)}
								{['FrontVehicleStart', 'TrafficLightViolation', 'StopSignViolation'].includes(event_setting) && eventDistanceTimeRender(sliderObj)}
								{['PedestrianWarning'].includes(event_setting) && eventSensitivityRender(sliderObj)}
							</>
						}
					</div>
				</div>
			</div>
		)
	}

	const dvSensitivitySettingRender = (sensitivitySetting, e = false) => {
		const {
			name,
			event_setting,
			event_type_name,
			description,
			sliderObj,
			sliderObjParkingTreshold,
			sublabel
		} = sensitivitySetting;
		if (isDV7 && !e && event_setting === 'BackUpWarning') return null;

		return (
			<div key={name} className="settings-card">
				<div className="card-header">
					<div>
						{name}
						{sublabel && <span className="sublabel">{sublabel}</span>}
					</div>

					<Toggle
						name={`Event.${event_setting}.Enabled`}
						checked={currentConfig.Event[event_setting].Enabled}
						icons={false}
						onChange={(e) => {
							fillFormBoolean(e, settingsType);
							resetSoundsToDefault(e, event_setting);
						}}
					/>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{/* animation of card-body content displaing with delay 0.5s */}
					<div className={`${!currentConfig.Event[event_setting].Enabled ? 'hide' : ''}`}>
						{/* Upload Type */}
						<SelectionEventVideoType
							name={event_type_name}
							value={event_types[event_type_name]}
							setEventTypes={setEventTypes}
						/>
						{!isDV4 && !['Accelerometer', 'BackUpWarning'].includes(event_setting) &&
							<>
								<SelectionSoundType
									name={event_setting}
									value={currentConfig.System.Chimes[event_setting]}
									setSoundTypes={setSoundTypes}
								/>
							</>}
						{/* Event Chime */}
						{!!isDV4 || (event_setting === "Accelerometer") &&
							<div className="toggle-wrapper">
								<label
									className="settings-title">{event_setting === 'Accelerometer' ? t('titleEventChime') : t('titleEventVoicePrompt')}</label>

								<div>
									<Toggle
										name={`System.Chimes.${event_setting}`}
										checked={currentConfig.System.Chimes[event_setting]}
										icons={false}
										onChange={(e) => fillFormBoolean(e, settingsType)}
									/>
									<SoundPlayButton soundKeyName={event_setting} iconButton value={currentConfig.System.Chimes[event_setting] ? 2 : 0} />
								</div>
							</div>}
						{/* Sound Type */}
						{['BackUpWarning'].includes(event_setting) && (
							<div className="toggle-wrapper">
								<label className="settings-title">{t('titleEventChime')}</label>
								<div>
									<Toggle
										name={`System.Chimes.${event_setting}`}
										checked={currentConfig.System.Chimes[event_setting]}
										icons={false}
										onChange={(e) => {
											const checked = e.target.checked;
											const value = checked ? 2 : 0;
											fillFormBoolean(e, settingsType, null, value);
										}}
									/>
									<SoundPlayButton iconButton value={currentConfig.System.Chimes[event_setting] ? 2 : 0} />
								</div>
							</div>
						)}
						{/* Sensitivity */}
						{!['BackUpWarning'].includes(event_setting) && eventSensitivityRender(sliderObj, event_setting)}
						{sliderObjParkingTreshold && ['Accelerometer'].includes(event_setting) && (
							<>
								<div className="card-header">
									<div>
										{name} ({t('parkingMode')})
									</div>

									<Toggle
										checked={!!currentConfig.Event.Accelerometer.ParkingThreshold.X}
										icons={false}
										onChange={(e) => {
											const checked = e.target.checked;
											const value = checked ? 0.05 : 0;
											onSensitivityTresholdChange({ target: { value } }, 'Event.Accelerometer.ParkingThreshold.X');
										}}
									/>
								</div>
								<div className="card-body sub-body">
									<p>{t('descriptionParkingMode')}</p>
									{!!currentConfig.Event.Accelerometer.ParkingThreshold.X && eventSensitivityRender(sliderObjParkingTreshold, event_setting)}
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		)
	}

	const dv7BlindSpotRender = (blindSpotsSettings) => {
		const { name, description, settings } = blindSpotsSettings;

		return (
			<div className="settings-card">
				<div className="card-header">
					<div>
						{name}
					</div>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{settings.map(item => {
						const { name, event_setting, event_sub_setting, event_type_name, sliderSpeedObj } = item;

						return (
							<React.Fragment key={event_type_name}>
								<ul className="blind-spot-list">
									<li>
										<div>
											<div>{name}</div>
											<Toggle
												name={`Event.${event_setting}.${event_sub_setting}.Enabled`}
												checked={currentConfig.Event[event_setting][event_sub_setting].Enabled}
												icons={false}
												onChange={(e) => {
													fillFormBoolean(e, settingsType);
													resetSoundsToDefault(e, event_setting, event_sub_setting);
												}}
											/>
										</div>
									</li>
								</ul>
								{currentConfig.Event[event_setting][event_sub_setting].Enabled ? (
									<>
										<SelectionEventVideoType
											name={event_type_name}
											value={event_types[event_type_name]}
											setEventTypes={setEventTypes}
										/>
										<div className="toggle-wrapper">
											<label
												className="settings-title">{t('titleEventChime')}</label>

											<div>
												<Toggle
													name={`System.Chimes.${event_setting}.${event_sub_setting}`}
													checked={currentConfig.System.Chimes[event_setting][event_sub_setting]}
													icons={false}
													onChange={(e) => {
														const checked = e.target.checked;
														const value = checked ? 2 : 0;
														fillFormBoolean(e, settingsType, null, value)
													}}
												/>
												<SoundPlayButton iconButton value={currentConfig.System.Chimes[event_setting][event_sub_setting] ? 2 : 0} />
											</div>
										</div>
										{eventSpeedRender(sliderSpeedObj)}
									</>
								) : ''}
							</React.Fragment>
						)
					})}
				</div>
			</div>
		)
	}

	const dv7SpeedLimitRender = (speedLimitSettings) => {
		const { name, description, sliderSpeedObj, settings } = speedLimitSettings;

		return (
			<div className="settings-card">
				<div className="card-header">
					<div>
						{name}
					</div>
				</div>
				<div className="card-body">
					<p>{description}</p>
					{eventSpeedRender(sliderSpeedObj)}
					<div className="configs-container">
						{settings.map(item => {
							const { name, event_setting, event_sub_setting, event_type_name } = item;

							return (
								<div className="speed-config">
									<div className="config-toggle">
										<div>{name}</div>
										<Toggle
											name={`Event.${event_setting}.${event_sub_setting}.Enabled`}
											checked={currentConfig.Event[event_setting][event_sub_setting].Enabled}
											icons={false}
											onChange={(e) => {
												fillFormBoolean(e, settingsType);
												resetSoundsToDefault(e, event_setting, event_sub_setting);
											}}
										/>
									</div>
									{currentConfig.Event[event_setting][event_sub_setting].Enabled ? (
										<>
											<SelectionEventVideoType
												name={event_type_name}
												value={event_types[event_type_name]}
												setEventTypes={setEventTypes}
											/>
											{event_sub_setting === 'Low' ? (
												<div className="toggle-wrapper">
													<label
														className="settings-title">{t('titleEventChime')}</label>

													<div>
														<Toggle
															name={`System.Chimes.${event_setting}.${event_sub_setting}`}
															checked={currentConfig.System.Chimes[event_setting][event_sub_setting]}
															icons={false}
															onChange={(e) => {
																const checked = e.target.checked;
																const value = checked ? 2 : 0;
																fillFormBoolean(e, settingsType, null, value)
															}}
														/>
														<SoundPlayButton iconButton value={currentConfig.System.Chimes[event_setting][event_sub_setting] ? 2 : 0} />
													</div>
												</div>
											) : (
												<SelectionSoundType
													name={event_setting}
													subType={event_sub_setting}
													value={currentConfig.System.Chimes[event_setting][event_sub_setting]}
													setSoundTypes={setSoundTypes}
												/>
											)}
										</>
									) : ''}
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}

	return (
		<main className="event-settings main-content-block">
			<h3 className="category-title">{t('titleEventSettings')}</h3>
			<div className="category-subheader">
				{t('subheaderEventSettings')}
				{!isDV4 &&
					<div className="button-group">
						<CustomButton
							onClick={() => setTabKey(1)}
							active={tabKey === 1}
						>
							{t('titleSafetyFeatures')}
						</CustomButton>
						<CustomButton
							onClick={() => setTabKey(2)}
							active={tabKey === 2}
						>
							{t('titleADASFeatures')}
						</CustomButton>
						<CustomButton
							onClick={() => setTabKey(3)}
							active={tabKey === 3}
						>
							{t('titleDMSFeatures')}
						</CustomButton>
						{isDV7 && <CustomButton
							onClick={() => setTabKey(4)}
							active={tabKey === 4}
						>
							{t('titleMultichannelFeatures')}
						</CustomButton>}
					</div>}
			</div>

			{tabKey === 1 &&
				(<div className="settings-card">
					<div className="card-header">
						{t('headerDriverEvent')}
						<Toggle
							name={!isDV4 ? "Enabled" : "Event.PanicButton.Enabled"}
							checked={!isDV4 ? Sensor4.Enabled : currentConfig.Event.PanicButton?.Enabled}
							icons={false}
							onChange={(e) => {
								!isDV4 ? fillFormSensors(e, 4) : fillFormBoolean(e, settingsType)
							}}
						/>
					</div>
					<div className="card-body">
						<p>{t('bodyDriverEvent')}</p>
						{/* anumation of card-body content displaing with delay 0.5s */}
						<div
							className={`${(!isDV4 && !Sensor4.Enabled) || (isDV4 && !currentConfig.Event.PanicButton?.Enabled) ? 'hide' : ''}`}>
							<SelectionEventVideoType
								name={isDV6 ? "dv6_driver" : isDV7 ? "dv7_driver" : "dv4_driver"}
								value={isDV6 ? event_types.dv6_driver : isDV7 ? event_types.dv7_driver : event_types.dv4_driver}
								setEventTypes={setEventTypes}
							/>
						</div>
					</div>
				</div>)
			}

			{isDV4 &&
				<div className="settings-card">
					<div className="card-header">
						{t('headerExternalDriverEvent')}
						<Toggle
							name="Enabled"
							checked={Sensor4.Enabled}
							icons={false}
							onChange={(e) => fillFormSensors(e, 4)}
						/>
					</div>
					<div className="card-body">
						<p>{t('bodyExternalDriverEvent')}</p>
						{/* anumation of card-body content displaing with delay 0.5s */}
						<div className={`${!Sensor4.Enabled ? 'hide' : ''}`}>
							<SelectionEventVideoType
								name="dv4_ext_driver"
								value={event_types.dv4_ext_driver}
								setEventTypes={setEventTypes}
							/>
						</div>
					</div>
				</div>
			}

			{tabKey === 1 &&
				(<div className="settings-card">
					<div className="card-header">
						{t('headerMaxSpeed')}
						<Toggle
							name="Event.HighSpeed.Enabled"
							checked={currentConfig.Event.HighSpeed.Enabled}
							icons={false}
							onChange={(e) => fillFormBoolean(e, settingsType)}
						/>
					</div>
					<div className="card-body">
						<p>{t('bodyMaxSpeed')}</p>
						{/* anumation of card-body content displaing with delay 0.5s */}
						<div className={`${!currentConfig.Event.HighSpeed.Enabled ? 'hide' : ''}`}>
							<SelectionEventVideoType
								name={isDV6 ? "dv6_high_speed" : isDV7 ? "dv7_high_speed" : "dv4_high_speed"}
								value={isDV6 ? event_types.dv6_high_speed : isDV7 ? event_types.dv7_high_speed : event_types.dv4_high_speed}
								setEventTypes={setEventTypes}
							/>
							{!isDV4 &&
								<SelectionSoundType
									name={"HighSpeed"}
									value={currentConfig.System.Chimes.HighSpeed}
									setSoundTypes={setSoundTypes}
								/>}
							<div className="toggle-wrapper button-group">
								<label className="settings-title">{t('titleMaxSpeedThreshold')}</label>
								<div>
									<input
										type="number"
										step="1"
										min="0"
										max="1000"
										maxLength="4"
										value={(currentConfig.System.SpeedUnit === 2) ? currentConfig.Event.HighSpeed.Threshold : (currentConfig.Event.HighSpeed.Threshold / 1.609344).toFixed(0)}
										className="vehicle-search number-input mr-10 pt-5"
										name="Event.HighSpeed.Threshold"
										onChange={(e) => fillForm(e, settingsType)}
									/>
									<label
										style={{ marginLeft: '6px' }}>{currentConfig.System.SpeedUnit === 2 ? 'KPH' : 'MPH'}</label>
								</div>
							</div>
						</div>
					</div>
				</div>)
			}

			{!isDV4 ? (
				<>
					{tabKey === 1 &&
						(<>
							{/* DV6 Sensitivity  */}
							{isDV6 && dv6SensitivitySettings.map((item) => dvSensitivitySettingRender(item))}
							{/* DV7 Sensitivity  */}
							{isDV7 && dv7SensitivitySettings.map((item) => dvSensitivitySettingRender(item))}
						</>
						)}

					{tabKey === 2 &&
						(<>
							{/* DV6 ADAS  */}
							{isDV6 && (dv6ADASSettings.map((item) => ADASSettingRender(item)))}
							{/* DV7 ADAS  */}
							{isDV7 && (dv7ADASSettings.map((item) => ADASSettingRender(item)))}

							<div className="settings-card">
								<div className="card-header">
									{t('headerADAS')}
								</div>
								<div className="card-body">
									<p>{t('bodyADAS')}</p>
									{eventDistanceTimeRender({
										name: 'Event.Adas.Headway.Ttc.TriggerThreshold',
										max: 3.0,
										min: 0.1,
										step: 0.1,
									})}
									{eventSpeedRender({
										name: 'Event.Adas.Headway.SpeedThreshold',
										min: getSpeedSlider(20),
										max: getSpeedSlider(55),
										step: 1,
									})}
								</div>
							</div>
							{isDV7 && (dv7ADASSettingsPart2.map((item) => ADASSettingRender(item)))}

							{isDV7 && dv7SpeedLimitRender(speedLimitSettings)}
						</>)
					}

					{tabKey === 3 &&
						(<>
							{/* DV6 DMS  */}
							{isDV6 && dv6DMSSettings.map((item) => DMSSettingRender(item))}
							{/* DV7 DMS  */}
							{isDV7 && dv7DMSSettings.map((item) => DMSSettingRender(item))}

							<div className="settings-card">
								<div className="card-header">
									{t('cardHeaderPotentialCh2')}
									<Toggle
										name="Event.Dms.CameraObstruction.Enabled"
										checked={currentConfig.Event.Dms.CameraObstruction.Enabled}
										icons={false}
										onChange={(e) => !isDV4 ? fillForm(e, settingsType) : fillFormBoolean(e, settingsType)}
									/>
								</div>
								<div className="card-body">
									<p>{t('cardBodyPotentialCh2')}</p>
									<div
										className={`${!currentConfig.Event.Dms.CameraObstruction.Enabled ? 'hide' : ''}`}>
										<ul>
											<li><b>{t('titleNoPrompt')}</b> - {t('descriptionNoPrompt')}</li>
											<li><b>{t('titleSingleChime')}</b> - {t('descriptionSingleChime')}</li>
											<li><b>{t('titleContinuousChime')}</b> - {t('descriptionContinuousChime')}
											</li>
											<li><b>{t('titleSinglePrompt')}</b> - {t('descriptionSinglePrompt')}</li>
											<li><b>{t('titleContinuousPrompt')}</b> - {t('descriptionContinuousPrompt')}
											</li>
										</ul>

										<SelectionEventVideoType
											name={isDV6 ? "dv6_camera_block" : "dv7_camera_block"}
											value={isDV6 ? event_types.dv6_camera_block : event_types.dv7_camera_block}
											setEventTypes={setEventTypes}
										/>

										<SelectionSoundType
											name="CameraObstruction"
											value={currentConfig.System.Chimes.CameraObstruction.SoundType}
											setSoundTypes={setSoundTypes}
										/>

										{!!currentConfig.System.Chimes.CameraObstruction.SoundType && (
											<div className="toggle-wrapper">
												<label
													className="settings-title">{t('cardHeaderVoicePromptFrequency')}</label>
												<div>
													<span className="subtitle mr-5">{t('textSingle')}</span>
													<Toggle
														name="System.Chimes.CameraObstruction.Enabled"
														checked={currentConfig.System.Chimes.CameraObstruction.Enabled === 2}
														icons={false}
														onChange={(e) => fillForm(e, settingsType)}
													/>
													<span className="subtitle">{t('textContinuous')}</span>
												</div>
											</div>)}

										{eventSpeedRender({
											name: 'Event.Dms.CameraObstruction.SpeedThreshold',
											min: getSpeedSlider(5),
											max: getSpeedSlider(35),
											step: 1,
										})}
									</div>
								</div>
							</div>
						</>)
					}

					{tabKey === 4 &&
						(<>
							{isDV7 && dv7BlindSpotRender(blindSpotsSettings)}
							{isDV7 && dvSensitivitySettingRender(dv7SensitivitySettings.find(item => item.event_setting === 'BackUpWarning'), true)}
						</>)
					}
				</>
			) : (
				<>
					{/* DV4 ADAS  */}
					{dv4ADASSettings.map((item) => ADASSettingRender(item))}

					<div className="settings-card">
						<div className="card-header">
							<div>
								{t('titleSpeedWarning')}
								<span className="subtitle">{t('subtitleRequiresMobileye')}</span>
							</div>
							<select
								placeholder="select"
								className="rosco-select"
								name="Event.Adas.SpeedThreshold"
								onChange={(e) => fillFormInt(e, settingsType)}
								value={currentConfig.Event.Adas.SpeedThreshold}
							>
								<option value="0">{t('textLevel')} 0 +[0 {unit}]</option>
								<option value="1">{t('textLevel')} 1 +[0-5 {unit}]</option>
								<option value="2">{t('textLevel')} 2 +[5-10 {unit}]</option>
								<option value="3">{t('textLevel')} 3 +[10-15 {unit}]</option>
								<option value="4">{t('textLevel')} 4 +[15-20 {unit}]</option>
								<option value="5">{t('textLevel')} 5 +[20-25 {unit}]</option>
								<option value="6">{t('textLevel')} 6 +[25-30 {unit}]</option>
								<option value="7">{t('textLevel')} 7 +[30-35 {unit}]</option>
								<option value="8">{t('textLevel')} 8 +[35 {unit}]</option>
							</select>
						</div>
						<div className="card-body">
							<p>{t('bodySpeedWarning')}</p>
						</div>
					</div>

					{/* DV4 DMS  */}
					{dv4DMSSettings.map((item) => DMSSettingRender(item))}
				</>
			)}

			{showModalDMSSeatbeltToggle &&
				<ModalDelete
					title={t('modalDeleteTitle')}
					content={t('modalDeleteContent')}
					showClose
					deleteBtnName={t('deleteBtnName')}
					closeBtnName={t('closeBtnName')}
					styleView="primary"
					backdropClassName="upper"
					closeModal={() => {
						setShowModalDMSSeatbeltToggle(false)
					}}
					deleteModal={showModalDMSSeatbeltToggle.function}
				/>
			}
		</main>
	)
}

export default FleetConfigurationEvent;
